/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 12/01/2025
 * @update 12/01/2025
 * @file src/components/W17/W17F3115
 */

import { Button, ButtonIcon, Card, CardBody, CardHeader, Col, Dropdown, Row, TextInput, Typography, DatePicker, Checkbox } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F3115Actions from "../../actions/w17/w17F3115/w17F3115-actions";
import Config from "../../config";
import { GoogleMap, PlaceIcon } from '../common/google-map/GoogleMap';
import { Loading } from "../common/loading/loading";
import MForm from "../common/form/form";

const FormID = 'W17F3115';
const keyExr = 'EmployeeLocationID';

const useStyles = makeStyles((theme) => {
    return ({
        board: {
            position: 'relative',
            height: (props) => `calc(100vh - ${props?.headerHeight}px)`
        },
        btnSearch: {
            top: 24,
            left: 24,
            position: 'absolute',
            zIndex: 1
        },
        btnClose: {
            position: 'absolute',
            top: 8,
            right: 8
        },
        placeInfo: {
            position: 'relative',
            bottom: (props) => 60 + (props?.infoBoardHeight),
            left: '-45px',
            width: 220,
            backgroundColor: theme.colors?.white,
            boxShadow: theme?.boxShadows?.large,
            padding: theme.spacing(3),
            zIndex: 100,
        }
    })
});

const defaultCenter = [10.776530, 106.700981]; // TPHCM

const InfoWindow = (props) => {
    const { place = {}, onPlaceClick } = props || {};
    const { EmployeeName = '', EmployeeAddress = '' } = place || {};
    const idInfoBoard = document.getElementById('infoBoard');
    let infoBoardHeight = idInfoBoard?.offsetHeight ?? 98;
    if (EmployeeAddress.length < 58) infoBoardHeight = 80;
    const classes = useStyles({ infoBoardHeight });
    return (
        <div id={'infoBoard'} className={classes.placeInfo}>
            <ButtonIcon
                circular
                size={'small'}
                name={'Cancel'}
                viewType={'ghost'}
                className={classes.btnClose}
                onClick={() => onPlaceClick(place)}
            />
            <Typography className={'mgr4x'}>{EmployeeName}</Typography>
            <Typography hoverTooltip type={'p2'} color={'secondary'} lineClamp={3}>{EmployeeAddress}</Typography>
        </div>
    );
};

// Marker component
const Marker = (props) => {
    const { show = false, place = {}, onPlaceClick } = props || {};
    return (
        <>
            <div style={{ cursor: 'pointer' }} onClick={() => onPlaceClick(place)}><PlaceIcon /></div>
            {show && <InfoWindow {...props} />}
        </>
    );
};

const requiredField = ['GroupEmployeeID', 'DateTo', 'DateFrom', 'EmployeeID'];
const W17F3115 = (props) => {
    let headerHeight = useRef(0);
    let defaultZoom = useRef(15);
    const classes = useStyles({ headerHeight: headerHeight.current });
    const [formLoading, setFormLoading] = useState(false);
    const [cboGroupEmployeeLoading, setCboGroupEmployeeLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [openModalSearch, setOpenModalSearch] = useState(true);
    const [iPermission, setIPermission] = useState(4);
    const [dataMaster, setDataMaster] = useState({
        StrSearch: '',
        EmployeeID: '',
        GroupEmployeeID: '',
        CheckinLocationDay: 0,
        DateFrom: null,
        DateTo: null
    });
    const [dataForm, setDataForm] = useState([]);
    const [dataCboGroupEmployee, setDataCboGroupEmployee] = useState([]);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    const [errors, setErrors] = useState({});
    const dataErrorRef = useRef(errors);
    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        headerHeight.current = document.getElementsByClassName('header-container')?.[0]?.offsetHeight ?? 0; // Chiều cao Thanh Header
        loadCboGroupEmployee();
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        if (!iPermission) return;
        loadCboEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataMaster.GroupEmployeeID]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (isPer) => {
            setIPermission(isPer);
        })
    };

    const loadCboGroupEmployee = () => {
        setCboGroupEmployeeLoading(true);
        props.W17F3115Actions.loadCboGroupEmployee({}, (error, data) => {
            setCboGroupEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboGroupEmployee(data);
            }
        })
    };

    const loadCboEmployee = () => {
        const { GroupEmployeeID = '' } = dataMaster;
        const params = {
            GroupEmployeeID
        };
        setCboEmployeeLoading(true);
        props.W17F3115Actions.loadCboEmployee(params, (error, data) => {
            setCboEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboEmployee(data);
            }
        })
    };

    const _setError = (dataError = {}, isReset = false) => {
        dataErrorRef.current = isReset ? { ...dataError } : { ...dataErrorRef.current, ...dataError };
        setErrors(dataErrorRef.current);
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const loadForm = (isSearch = false) => {
        const { StrSearch = '', EmployeeID = '', GroupEmployeeID = '', CheckinLocationDay, DateFrom = null, DateTo = null } = dataMaster;
        const params = {
            StrSearch,
            EmployeeID,
            GroupEmployeeID,
            CheckinLocationDay,
            DateFrom,
            DateTo

        };
        if (isSearch && !!CheckinLocationDay){
            const resultValidate = checkValidateMaster(requiredField);
            const validateFrom = MForm.formValidation(resultValidate);
            if (Object.keys(validateFrom).length > 0) {
                _setError(validateFrom, true);
                return false;
            }
        }
        setFormLoading(true);
        props.W17F3115Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const customDataForm = data.map(item => ({ ...item, EmployeeCoordinates: (item?.EmployeeCoordinates || '').split(',') }));
                if (customDataForm.length > 1) {
                    const kt = Math.floor(customDataForm?.[0]?.EmployeeCoordinates?.[0]);
                    const vd = Math.floor(customDataForm?.[0]?.EmployeeCoordinates?.[1]);
                    const isOtherArea = customDataForm.slice(1, customDataForm.length).some(item => Math.floor(item?.EmployeeCoordinates?.[0]) !== kt || Math.floor(item?.EmployeeCoordinates?.[1]) !== vd);
                    if (isOtherArea) defaultZoom.current = 10; // Zoom ra
                }
                setDataForm(customDataForm);
            }
        })
    };

    const btnSearchAction = () => {
        setOpenModalSearch(!openModalSearch);
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if(['DateTo', 'DateFrom'].includes(fieldName) && Config.isEmpty(value)) value = null;
        else if(fieldName === 'CheckinLocationDay') {
            value = +value;
            if(!value) setErrors({})
        }
        setDataMaster({ ...dataMaster, [fieldName]: value });
        if (!Config.isEmpty(value) && errors?.[fieldName]) setErrors({ ...errors, [fieldName]: '' });
    };

    const renderSearchBoard = () => {
        return (
            <Card width={474} className={classes.btnSearch}>
                <CardHeader>
                    <div className={'full_w display_row align-center align-between'}>
                        <Typography type={'h3'}>{Config.lang('Tim_nhan_vien')}</Typography>
                        <ButtonIcon
                            circular
                            viewType={'ghost'}
                            name={'Cancel'}
                            color={'primary'}
                            onClick={btnSearchAction}
                        />
                    </div>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col xs={12}>
                            <TextInput
                                viewType={'outlined'}
                                value={dataMaster?.StrSearch}
                                placeholder={Config.lang('Tim_ten_nhan_vien')}
                                onChange={(e) => onChange('StrSearch', e)} />
                        </Col>
                        <Col xs={12}>
                            <Dropdown
                                clearAble
                                viewType={'outlined'}
                                valueExpr={'GroupSalesID'}
                                displayExpr={'GroupSalesName'}
                                label={Config.lang('Nhom_NV')}
                                loading={cboGroupEmployeeLoading}
                                value={dataMaster?.GroupEmployeeID}
                                dataSource={dataCboGroupEmployee}
                                error={errors && errors["GroupEmployeeID"]}
                                required={dataMaster?.CheckinLocationDay === 1}
                                onChange={e => onChange('GroupEmployeeID', e)}
                            />
                        </Col>
                        <Col xs={12}>
                            <Dropdown
                                clearAble
                                viewType={'outlined'}
                                valueExpr={'EmployeeID'}
                                displayExpr={'EmployeesName'}
                                label={Config.lang('Nhan_vien')}
                                loading={cboEmployeeLoading}
                                value={dataMaster?.EmployeeID}
                                dataSource={dataCboEmployee}
                                error={errors?.EmployeeID}
                                required={dataMaster?.CheckinLocationDay === 1}
                                onChange={e => onChange('EmployeeID', e)}
                            />
                        </Col>
                        <Col xs={12}>
                            <Checkbox
                                checked={dataMaster?.CheckinLocationDay === 1}
                                label={Config.lang("Vi_tri_check_in_trong_ngay")}
                                color={'primary'}
                                onChange={e => onChange('CheckinLocationDay', e)}
                            />
                        </Col>
                        <Col xs={12} sm={12} md={6} >
                            <DatePicker
                                label={Config.lang("Ngay_tu")}
                                value={dataMaster?.DateFrom}
                                onChange={e => onChange('DateFrom', e)}
                                max={dataMaster?.DateTo}
                                viewType={'outlined'}
                                error={errors?.DateFrom}
                                required={dataMaster?.CheckinLocationDay === 1}
                            />
                        </Col>
                        <Col xs={12} sm={12} md={6}>
                            <DatePicker
                                label={Config.lang("Ngay_den")}
                                value={dataMaster?.DateTo}
                                onChange={e => onChange('DateTo', e)}
                                min={dataMaster?.DateFrom}
                                viewType={'outlined'}
                                error={errors?.DateTo}
                                required={dataMaster?.CheckinLocationDay === 1}
                            />
                        </Col>
                        <Col xs={12}>
                            <div className={'full_w'} style={{ textAlign: 'right' }}>
                                <Button
                                    color={'primary'}
                                    startIcon={'Search'}
                                    viewType={'outlined'}
                                    label={Config.lang('Tim_kiem')}
                                    onClick={() => loadForm(true)}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    };

    const onClickViewBoard = (data) => {
        const { [keyExr]: id = '' } = data;
        const dataFormArr = [];
        for (let i = 0; i < dataForm.length; i++) {
            if (dataForm[i]?.[keyExr] === id) dataForm[i].show = !dataForm[i]?.show; // eslint-disable-line no-param-reassign
            dataFormArr.push(dataForm[i]);
        }
        setDataForm(dataFormArr);
    };


    if (!iPermission) return null;
    return (
        <div className={`${classes.board} display_row align-center valign-middle`}>
            {formLoading && <Loading />}
            <ButtonIcon
                viewType={'filled'}
                size={'giant'}
                name={'Search'}
                color={'white'}
                className={classes.btnSearch}
                onClick={btnSearchAction}
            />
            {openModalSearch && renderSearchBoard()}
            <GoogleMap
                defaultZoom={defaultZoom.current}
                defaultCenter={Config.isEmpty(dataForm) ? defaultCenter : dataForm[0]?.EmployeeCoordinates} >
                {dataForm && dataForm.map((place) => {
                    const { [keyExr]: id, show, EmployeeCoordinates } = place || {};
                    return (
                        <Marker
                            key={id}
                            show={show}
                            place={place}
                            lat={EmployeeCoordinates?.[0]}
                            lng={EmployeeCoordinates?.[1]}
                            onPlaceClick={onClickViewBoard}
                        />
                    )
                })}
            </GoogleMap>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W17F3115Actions: bindActionCreators(W17F3115Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F3115);


